// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"85":"mobile","220":"serve","239":"joinUs","454":"newsList","522":"aboutUs","592":"productInfo","964":"product","970":"newsInfo"}[chunkId] + "." + {"85":"85a416eb","220":"2c2120d1","239":"a14afbe8","454":"7e0f174b","522":"7c1cc42f","592":"ba78cf97","964":"6de23843","970":"dcfc8e4c"}[chunkId] + ".js";
};